import React from "react";
import truck from "../assets/img/Truck.png";
import { Col, Container, Row } from "reactstrap";

function Footer() {
    return (
        <Container fluid className="footer mt-5 text-white">
            <Row>
                <Col lg={3} md={3} sm={12} xs={12}>
                    <div>
                        <img src={truck} width="80%" height="80%" alt="" />
                        <p className="px-4">Boston, MA</p>
                        {/* <h3 className="px-4">#DistributerSupplies</h3> */}
                    </div>
                </Col>
                {/* <Col
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    className="d-flex justify-content-center align-items-center"
                >
                    <ul className="footer__ul">
                        <h4>Products</h4>
                        <li>Delivery Services</li>
                        <li>Online Store</li>
                        <li>IDA Members</li>
                        <li>Brick & Marters</li>
                    </ul>
                </Col> */}
                {/* <Col
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    className="d-flex justify-content-center align-items-center"
                >
                    <ul className="footer__ul">
                        <h4>Services</h4>
                        <li>Delivery Services</li>
                        <li>Online Store</li>
                        <li>IDA Members</li>
                        <li>Brick & Marters</li>
                    </ul>
                </Col> */}
            </Row>
            <hr className="hr" />
            <Row className="p-3">
                <Col md={6} sm={12} xs={12}>
                    <span>
                        © 2023 Where to Buy Detailing Supplies.com. All rights
                        reserved.
                    </span>
                    <br />
                    <a href="#" className="text-white ml-1 mr-2">
                        Privacy Terms
                    </a>{" "}
                    |
                    <a href="#" className="text-white ml-1 mr-2">
                        Services
                    </a>
                    |
                    <a href="#" className="text-white ml-1 mr-2">
                        Products
                    </a>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                    <p>POWERED BY MYDISTRIBUTIONPARTNER.com</p>
                </Col>
            </Row>
        </Container>
    );
}

export default Footer;
